import React from "react";

import FileUploadDetail from "../component/FileUploadDetail";

const FileUploadDetailContainer = ({ pageId }) => (<FileUploadDetail pageId={ pageId } />)

export default FileUploadDetailContainer; 
